import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTag = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.125 2C10.7939 2 11.4215 2.26058 11.8936 2.7334L21.2676 12.1074C21.7396 12.5794 22 13.2069 22 13.875C22 14.5431 21.7396 15.1706 21.2676 15.6426L15.6426 21.2676C15.1706 21.7396 14.5431 22 13.875 22C13.2069 22 12.5794 21.7396 12.1074 21.2676L2.73242 11.8926C2.26041 11.4214 2 10.7939 2 10.125V4.5C2 3.12142 3.12142 2 4.5 2H10.125ZM4.5 3.25C3.81071 3.25 3.25 3.81071 3.25 4.5V10.125C3.25 10.4594 3.38015 10.7726 3.61523 11.0078L12.9912 20.3838C13.4632 20.8558 14.2868 20.8558 14.7588 20.3838L20.3838 14.7588C20.6198 14.5228 20.75 14.2087 20.75 13.875C20.75 13.5413 20.6198 13.2272 20.3838 12.9912L11.0088 3.61621C10.7728 3.38021 10.4595 3.25 10.125 3.25H4.5ZM6.375 4.5C7.40852 4.5 8.25 5.34148 8.25 6.375C8.25 7.40852 7.40852 8.25 6.375 8.25C5.34148 8.25 4.5 7.40852 4.5 6.375C4.5 5.34148 5.34148 4.5 6.375 4.5ZM6.375 5.75C6.03076 5.75 5.75 6.03076 5.75 6.375C5.75 6.71924 6.03076 7 6.375 7C6.71924 7 7 6.71924 7 6.375C7 6.03076 6.71924 5.75 6.375 5.75Z",
		fill: "currentColor"
	})
});
export default SvgTag;
